// extracted by mini-css-extract-plugin
export default {"container":"Error_container__Yxy-I","appear":"Error_appear__O1B-U"};